import axios from "./axios";

export async function fetchJobOpenings(controller = {}) {
  return axios({ method: "get", url: "/job_openings", params: controller })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function fetchJobOpening(id) {
  return axios({ method: "get", url: `/job_openings/${id}` })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function createJobOpening(payload) {
  return axios
    .post("/job_openings", { job_opening: payload })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function updateJobOpening(payload) {
  return axios
    .put(`/job_openings/${payload.id}`, { job_opening: payload })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function deleteJobOpening(id) {
  return axios
    .delete(`/job_openings/${id}`)
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function bulkImportJobOpenings(payload) {
  return axios
    .post("/job_openings/bulk_import", { payload })
    .then((response) => response.data);
}
